import { PageFilter } from "../../shared/components/filter";
import { PageHeading } from "../../shared/components/heading";
import { useParams } from "react-router-dom";
import request from "../../shared/utils/request";
import { useEffect, useState } from "react";
import { formatDate } from "../../shared/utils/dateFormat";
import { Link } from "react-router-dom";
import { Loader } from "../../shared/components/loader";
import "../myLibrary/style.css";

export const Questions = () => {
  const [loading, setLoading] = useState(false);
  const [cardDatas, setCardDatas] = useState([]);

  const { date } = useParams();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await request.get(
        `student/getGrammerBookAnswersByDate?date=${date}`
      );
      if (response?.data?.success) {
        setCardDatas(response?.data?.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="services" className="services section my-library">
      <div className="container section-title" data-aos="fade-up">
        <PageHeading heading={"My Answers"} />
      </div>
      <Loader isLoading={loading} />
      <div className="container">
        <div className="row gy-1">
          {cardDatas?.map((cardData, rowIndex) => (
            <div className="col-md-4 " key={rowIndex}>
              <Link to={`/student/my-answer-details/${cardData?.id}`}>
                <div className="card-wrapper">
                  <div className="custom-card">
                    <div className="card-body ml-2">
                      <span className="badge badge-custom text-white">
                        Click to View
                      </span>
                      <h5 className="card-title">
                        {cardData?.grammerbook?.question}
                      </h5>
                    </div>
                    <span
                      class={`badge ${
                        cardData?.submit_status
                          ? "text-bg-success"
                          : "text-bg-danger"
                      }`}
                    >
                      {cardData?.submit_status
                        ? "Submitted for review"
                        : "Not submitted for review"}
                    </span>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
